import { __decorate } from "tslib";
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
export const SpaceAdminModel = Symbol('SpaceAdminModel');
let SpaceAdminModelImpl = class SpaceAdminModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = {
            admins: [],
            loading: false,
        };
    }
    dispose() {
        this.update(() => ({
            admins: [],
            loading: false,
        }));
    }
};
SpaceAdminModelImpl = __decorate([
    injectable()
], SpaceAdminModelImpl);
export { SpaceAdminModelImpl };
